import {post} from "@/utils/request";

// 获取公司详情
export function getCompanyDetail(params){
  const {id} = params
  const param = {
    id  // 导入公司ID
  }
  return post('/enterprise/importInfo',param)
}